export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  SERVICES: '/services',
  DIGITAL_WALLET: '/digital-wallet',
  DIGITAL_CARD: '/digital-card',
  BRANCHES: '/branches',
  BENEFITS: '/benefits',
  CONTACT_US: '/contact-us',
  GENERAL: '/general',
  FAQ: '/faq',
  USEFUL_INFORMATION: '/useful-information',
  ARTICLES: '/articles',
  TERMS_UPDATE: '/terms-update'
} as const

export const NAV_LINKS = [
  { href: ROUTES.ABOUT, label: 'company.about' },
  { href: ROUTES.SERVICES, label: 'company.services' },
  { href: ROUTES.DIGITAL_WALLET, label: 'company.digitalWallet' },
  { href: ROUTES.DIGITAL_CARD, label: 'company.digitalCard' },
  { href: ROUTES.BENEFITS, label: 'company.benefits' },
  { href: ROUTES.BRANCHES, label: 'company.branches' },
  { href: ROUTES.CONTACT_US, label: 'company.contact' }
]

export const FOOTER_LINKS = {
  company: [
    { href: ROUTES.ABOUT, label: 'company.about' },
    { href: ROUTES.SERVICES, label: 'company.services' },
    { href: ROUTES.DIGITAL_WALLET, label: 'company.digitalWallet' },
    { href: ROUTES.DIGITAL_CARD, label: 'company.digitalCard' },
    { href: ROUTES.BRANCHES, label: 'company.branches' },
    { href: ROUTES.BENEFITS, label: 'company.benefits' },
    { href: ROUTES.CONTACT_US, label: 'company.contact' }
  ],
  general: [
    { href: `${ROUTES.GENERAL}#legal-acts`, label: 'general.legalActs' },
    { href: `${ROUTES.GENERAL}#shareholders`, label: 'general.shareholders' },
    { href: `${ROUTES.GENERAL}#reports`, label: 'general.reports' },
    { href: `${ROUTES.GENERAL}#documents`, label: 'general.documents' },
    { href: `${ROUTES.GENERAL}#complaints`, label: 'general.complaints' },
    { href: ROUTES.FAQ, label: 'general.faq' }
  ],
  usefulInformation: [
    {
      href: `${ROUTES.USEFUL_INFORMATION}#financial-mediator`,
      label: 'usefulInformation.financialMediator'
    },
    {
      href: `${ROUTES.USEFUL_INFORMATION}#announcements`,
      label: 'usefulInformation.announcements'
    },
    {
      href: `${ROUTES.USEFUL_INFORMATION}#links`,
      label: 'usefulInformation.links'
    }
  ],
  contact: [
    { href: '#', label: 'contact.location' },
    {
      href: 'tel:+374 10 300 003',
      label: 'contact.phone'
    },
    { href: 'mailto:info@teampay.am', label: 'contact.email' }
  ]
}

export const FOOTER_NAV_TITLES = {
  company: 'company.title',
  general: 'general.title',
  usefulInformation: 'usefulInformation.title',
  contact: 'contact.title'
}
